export interface CashCloseCashOfferShape {
  id: number;
  hl_order_id: number;
  created_at: string;
  updated_at: string;
  stage: string; // TODO: new, connected, application_started, _complete ...
  incoming_residence_address: string;
  incoming_residence_cash_close_fee: number;
  incoming_residence_coe: string;
  express_close: boolean;
}

export interface CashCloseCashTradeInShape {
  id: number;
  hl_order_id: number;
  created_at: string;
  updated_at: string;
  stage: string; // TODO: new, connected, application_started, _complete ...
  departing_residence_address: string;
  departing_residence_preliminary_home_value: string;
  departing_residence_home_valuation: string;
  departing_residence_escrow_ordered: string;
  departing_residence_guaranteed_sale_price: string;
  departing_residence_cash_close_fee: string;
  departing_residence_ownership_expenses: string;
  departing_residence_transfer_tax: string;
  departing_residence_listing_prep_fee: string;
  departing_residence_disbursement_date: string;
  incoming_residence_address: string;
  trade_in_plus: boolean;
}

export enum CashCloseTradeInStages {
  New = "new",
  Connected = "connected",
  Pitched = "pitched",
  ApplicationStarted = "application_started",
  ApplicationComplete = "application_complete",
  InspectionComplete = "inspection_complete",
  Approved = "approved",
  AgreementSigned = "agreement_signed",
  InEscrowPurchase = "in_escrow_purchase",
  InEscrowSell = "in_escrow_sell",
  ClosedPurchase = "closed_purchase",
  ClosedSell = "closed_sell",
  ClosedPaid = "closed_paid",
  Listed = "listed",
  Failed = "failed",
  Nurture = "nurture",
}

export const CashCloseTradeInStageDisplayValues = {
  [CashCloseTradeInStages.New]: "New",
  [CashCloseTradeInStages.Connected]: "Connected",
  [CashCloseTradeInStages.Pitched]: "Pitched",
  [CashCloseTradeInStages.ApplicationStarted]: "Application started",
  [CashCloseTradeInStages.ApplicationComplete]: "Application complete",
  [CashCloseTradeInStages.InspectionComplete]: "Inspection complete",
  [CashCloseTradeInStages.Approved]: "Approved",
  [CashCloseTradeInStages.AgreementSigned]: "Agreement signed",
  [CashCloseTradeInStages.InEscrowPurchase]: "In escrow purchase",
  [CashCloseTradeInStages.InEscrowSell]: "In escrow sell",
  [CashCloseTradeInStages.ClosedPurchase]: "Closed purchase",
  [CashCloseTradeInStages.ClosedSell]: "Closed sell",
  [CashCloseTradeInStages.ClosedPaid]: "Closed paid",
  [CashCloseTradeInStages.Listed]: "Listed",
  [CashCloseTradeInStages.Failed]: "Failed",
  [CashCloseTradeInStages.Nurture]: "Nurture",
};

export enum CashCloseCashOfferStages {
  New = "new",
  Connected = "connected",
  Pitched = "pitched",
  ApplicationStarted = "application_started",
  ApplicationComplete = "application_complete",
  Approved = "approved",
  AgreementSigned = "agreement_signed",
  MakingOffers = "making_offers",
  OfferAccepted = "offer_accepted",
  InEscrowPurchase = "in_escrow_purchase",
  ClosedPurchase = "closed_purchase",
  InEscrowSell = "in_escrow_sell",
  ClosedSell = "closed_sell",
  ClosedPaid = "closed_paid",
  Failed = "failed",
  Nurture = "nurture",
}

export const CashCloseCashOfferStageDisplayValues = {
  [CashCloseCashOfferStages.New]: "New",
  [CashCloseCashOfferStages.Connected]: "Connected",
  [CashCloseCashOfferStages.Pitched]: "Pitched",
  [CashCloseCashOfferStages.ApplicationStarted]: "Application started",
  [CashCloseCashOfferStages.ApplicationComplete]: "Application complete",
  [CashCloseCashOfferStages.Approved]: "Approved",
  [CashCloseCashOfferStages.AgreementSigned]: "Agreement signed",
  [CashCloseCashOfferStages.MakingOffers]: "Making offers",
  [CashCloseCashOfferStages.OfferAccepted]: "Offer accepted",
  [CashCloseCashOfferStages.InEscrowPurchase]: "In escrow purchase",
  [CashCloseCashOfferStages.ClosedPurchase]: "Closed purchase",
  [CashCloseCashOfferStages.InEscrowSell]: "In escrow sell",
  [CashCloseCashOfferStages.ClosedSell]: "Closed sell",
  [CashCloseCashOfferStages.ClosedPaid]: "Closed paid",
  [CashCloseCashOfferStages.Failed]: "Failed",
  [CashCloseCashOfferStages.Nurture]: "Nurture",
};

export enum CashCloseTypes {
  TradeIn = "trade_in",
  CashOffer = "cash_offer",
  CashOfferExpress = "cash_offer_express",
  TradeInCashOffer = "trade_in_cash_offer",
  TradeInPlus = "trade_in_plus",
  TradeInPlusCashOffer = "trade_in_plus_cash_offer",
  None = "none",
}

export const humanizedCashCloseTypes = {
  [CashCloseTypes.TradeIn]: "Trade-In",
  [CashCloseTypes.CashOffer]: "Cash Offer",
  [CashCloseTypes.CashOfferExpress]: "Cash Offer Express",
  [CashCloseTypes.TradeInCashOffer]: "Trade-In & Cash Offer",
  [CashCloseTypes.TradeInPlus]: "Trade-In+",
  [CashCloseTypes.TradeInPlusCashOffer]: "Trade-In+ & Cash Offer",
  [CashCloseTypes.None]: "None",
};
